export default function CircularTickIcon({
    style,
    fill = "#83CFA4",
}) {
    return <svg style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="9" fill={fill} />
        <path d="M5.45931 10.0724L7.84357 12.0548L13.0004 6.49978" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

}